import Vue from 'vue'
import moment from 'moment'
import { transformUrl } from '@/utils/util'
import 'moment/locale/zh-cn'
import store from '@/store'

moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter('fileUrl', function (url) {
  return transformUrl(url)
})

Vue.filter('dict', function (val, type) {
  if (store.state.materiel[type] && store.state.materiel[type][val]) {
    return store.state.materiel[type][val]
  }
  return val
})
